<template>
  <div>
    <div id="search">
      <el-row  v-if="version == '2'" style="height: 40px;font-size: 14px">
        <el-col>
          <el-button type="primary"  size="mini" style="margin-left: 10px" @click="refresh">刷新</el-button>
          排序：<el-select v-model="orderField" size="mini" style="width: 160px" placeholder="请选择">
          <el-option
            v-for="item in orderOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
          <el-select v-model="asc" size="mini" style="width: 80px" placeholder="请选择">
            <el-option
              v-for="item in ascOpto"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          商品名称：<el-input v-model="title" size="mini" style="width: 360px"></el-input>
        </el-col>
      </el-row>
      <el-row style="font-size: 12px">
        <el-col :span="23">
          <el-checkbox v-model="span" style="font-size: 12px; margin-right: 15px">按订单号合并</el-checkbox>
          <el-checkbox v-model="onlyWaitSend"  style="margin-right: 5px">只看待发货(不含退款)</el-checkbox>
          订单号：<el-input v-model="tid" size="mini" style="width: 180px"></el-input>

          <el-select v-model="timeField" size="mini" style="width: 100px" placeholder="请选择">
            <el-option
              v-for="item in timeOpto"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <el-date-picker
            style="width: 320px" size="mini"
            :default-time="['00:00:00', '23:59:59']"
            v-model="payTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
          </el-date-picker>
          旗帜：<el-select v-model="sellerFlag" size="mini" style="width: 100px" placeholder="请选择">
          <el-option
            v-for="item in flagOpto"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
          <el-button type="primary" size="mini"  @click="getTradeData" >搜索</el-button>
        </el-col>

        <el-col :span="1">

        </el-col>
      </el-row>
      <div style="margin: 0px 0;"></div>
      <div style="width:2px;height:3px;margin-left: 30px; margin-top:0px; border-top: #dd6161 0px solid" @click="change"></div>
      <el-row style="margin: 5px 0px">
        <el-col>

          <el-button type="primary" size="mini" @click="expExcel">导出</el-button>
          <span style="font-size: 12px;">隐私数据: </span><span style="font-size: 12px;border-bottom: 1px red solid">姓名,手机,电话,收货地址</span>
          <span style="font-size: 12px;margin-left: 30px">请输入手机号：</span><el-input size="mini" v-model="mobile" style="width: 120px"></el-input>
          <el-button type="primary" size="mini" @click="sendCheckCode">获取验证码</el-button>
          <span style="font-size: 12px">请输入验证码：</span><el-input size="mini" v-model="code" style="width: 100px"></el-input>
          <el-button type="primary" size="mini" @click="checkCode">验证</el-button>

        </el-col>
      </el-row>

      <div class="block" align="left" style="margin-left: 200px; color: #000">

        <span class="demonstration"></span>
        <el-pagination style="color: #000"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pageObject.pageCurrent"
                       :page-sizes="[50, 100, 500, 1000, 2000, 5000]"
                       :page-size="pageObject.pageSize"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pageObject.rowCount">
        </el-pagination>
      </div>

    </div>


    <el-row>
      <el-col :span="8">
        <el-button type="primary" size="mini" @click="hide" style="float: left">全屏显示/恢复</el-button>
        <el-button type="primary" size="mini" @click="batDecrypt" style="float: left">批量明文</el-button>
      </el-col>
    </el-row>
    <div style="height:15px; width:50px;margin-left:0px; margin-top:0px; border-bottom: #dd6161 0px solid;font-size: 12px" @click="getTrueInfo"></div>
    <el-row>
      <el-col :span="24">
        <div id="mytable">
          <el-table :height="tableHeight" :data="tradeData" border style="font-size: 12px; font-family: 幼圆  "  :header-cell-style="{ background:'#F2F6FC',color:'#000'}" :span-method="objectSpanMethod" :row-class-name="tableRowClassName">
            <el-table-column  label="明文" width="50px">
              <template slot-scope="scope">
                <el-button type="text" size="small"  style="display: inline" @click="decrypt(scope.$index, scope.row)">明文</el-button>
              </template>
            </el-table-column>
            <template v-for='(col) in myFields' style="word-wrap:break-word;" >
              <el-table-column v-if="col.field!='picPath'"
                               :show-overflow-tooltip="false"
                               :prop="col.field"
                               :label="col.title"
                               :key="col.field"
                               width="170px"
              >
              </el-table-column>
            </template>

            <el-table-column label="主图" v-if="showImg == '1'" width="160px">
              <template slot-scope="scope" >
                <img width="100px" height="100px" :src="scope.row.picPath.replace('800x800','200x200')" />
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div  id="vTable" style="display:none">  <!--style="position: absolute;top: -100000000px;display:none"-->
          <el-table  :height="tableHeight"  :data="tradeData" border style="font-size: 12px"
                     :header-cell-style="{ background:'#F2F6FC',color:'#000'}" :span-method="objectSpanMethod" :row-class-name="tableRowClassName">
            <el-table-column  label="明文" width="50px">
              <template slot-scope="scope">
                <el-button type="text" size="small"  style="display: inline" @click="decrypt(scope.$index, scope.row)">明文</el-button>
              </template>
            </el-table-column>
            <template v-for='(col) in hideFields' style="word-wrap:break-word;" >
              <el-table-column v-if="col.field!='picPath'"
                               :show-overflow-tooltip="false"
                               :prop="col.field"
                               :label="col.title"
                               :key="col.field"
                               width="170px"
              >
              </el-table-column>
            </template>

            <el-table-column label="主图" v-if="showImg == '1'" width="160px">
              <template slot-scope="scope" >
                <img width="100px" height="100px" :src="scope.row.picPath.replace('800x800','200x200')" />
              </template>
            </el-table-column>
          </el-table>
        </div>


        <el-button v-if="false" @click="change">Copy</el-button>

      </el-col>
    </el-row>

    <div id="page" class="block" align="center">
      <span class="demonstration"></span>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObject.pageCurrent"
        :page-sizes="[ 50, 100, 500, 1000, 2000, 5000]"
        :page-size="pageObject.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObject.rowCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"
  import copy from "../api/copy"

    export default {
        name: "ShowData",
      data(){
        return{
          version:"2",
          deny:0,
          mobile:'',
          code:'',
          validCode:'',
          isChecked:false,
          display:1,
          span:false,
          showImg:'1',
          bigImg:'0',
          myFields:[],
          hideFields:[],
          tradeData:[],

          tid:'',
          payTime:[],
          title:'',

          hasMemo:false,
          hasSellerRate:false,
          onlyWaitSend:false,
          showRefund:false,
          timeField:'A.createTime',
          timeOpto:[{value:'A.createTime',label:'拍下时间'}, {value:'A.payTime',label:'付款时间'}],
          sellerFlag:-1,
          flagOpto:[{value:-1,label:'全部'},{value:0,label:'0-灰色'},{value:1,label:'1-红色'},{value:2,label:'2-黄色'},{value:3,label:'3-绿色'},{value:4,label:'4-蓝色'},{value:5,label:'5-紫色'}],
          orderField:'A.createTime',
          orderOpto:[{value:'A.createTime',label:'拍下时间'}, {value:'A.payTime',label:'付款时间'}],
          asc:'desc',
          ascOpto:[{value:'asc',label:'正序'},{value:'desc',label:'倒序'}],
          excelFlg:0,
          tableHeight: window.innerHeight - 80,
          pageObject: {
            pageCurrent: 1,
            rowCount: 0,
            pageSize: 50,
          },
          pickerOptions: {
            shortcuts: [{
              text: '今天',
              onClick(picker) {
                const end = new Date();

                let year2, month2, day2
                [year2, month2, day2] = [end.getFullYear(), end.getMonth(), end.getDate()]
                let start = new Date(year2, month2, day2, 0)
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }]
          },
        }
      },
      methods:{
        hide:function(){
          this.display++;
          if(this.display % 2 == 0){
            window.document.getElementById("left").style.display = 'none';
            window.document.getElementById("top").style.display = 'none';
            window.document.getElementById("search").style.display = 'none';
            window.document.getElementById("page").style.display = 'none';
          }else {
            window.document.getElementById("left").style.display = 'block';
            window.document.getElementById("top").style.display = 'block';
            window.document.getElementById("search").style.display = 'block';
            window.document.getElementById("page").style.display = 'block';
          }

        },
        refresh(){
          this.$router.go(0);
        },
        prepareExport:function(){
          /*let fields=" 姓名，手机，电话，收货信息，收货地址，详细地址，买家支付宝"
          for(let i=0;i<this.myFields.length;i++){
            if(fields.indexOf(this.myFields[i].title)>0){
              this.$message.error("禁止导出隐私数据, 如需导出，请去除隐私数据！");
              return;
            }
          }*/
          //导出时自动设置为最大页数，获取数据后，如果标记是导出，则执行导出操作
          this.excelFlg = 1;
          this.pageObject.pageSize = 5000;
          this.getTradeData();
        },

        //   点击按钮  导出excel表格：
        export2Excel: function() {
          if(this.tradeData.length == 0){
            this.$message.error("没有订单数据，无需导出。");
            return;
          }
          //是否通过验证
          if(!this.isChecked){
            this.$message.error( "请先获取验证码，验证通过后再导出。" );
            return;
          }
          //导出只能导出加密的信息
          //this.getTradeData();
          // 设置当前日期
          let nick = storage.get("nick");
          let time = new Date();
          let year = time.getFullYear();
          let month = time.getMonth() + 1;
          let day = time.getDate();
          let name = nick +"_"+ year + "" + month + "" + day;

          let tables = document.getElementById("mytable");
          let table_book = this.$XLSX.utils.table_to_book(tables);
          var table_write = this.$XLSX.write(table_book, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
          });
          try {
            this.$FileSaver.saveAs(
              new Blob([table_write], { type: "application/octet-stream" }), name.replace("*","")+".xlsx");
          } catch (e) {
            if (typeof console !== "undefined") console.log(e, table_write);
          }
          this.isChecked = false;
          return table_write;
        },
        //   点击按钮  导出excel表格：
        export2Excel: function() {
          if(this.tradeData.length == 0){
            this.$message.error("没有订单数据，无需导出。");
            return;
          }
          //是否通过验证
          if(!this.isChecked){
            this.$message.error( "请先获取验证码，验证通过后再导出。" );
            return;
          }
          //导出只能导出加密的信息
          //this.getTradeData('');
          // 设置当前日期
          let nick = storage.get("nick");
          let time = new Date();
          let year = time.getFullYear();
          let month = time.getMonth() + 1;
          let day = time.getDate();
          let name = nick +"_"+ year + "" + month + "" + day;

          let tables = document.getElementById("mytable");
          let table_book = this.$XLSX.utils.table_to_book(tables);
          var table_write = this.$XLSX.write(table_book, {
            bookType: "xlsx",
            bookSST: true,
            type: "array"
          });
          try {
            this.$FileSaver.saveAs(
              new Blob([table_write], { type: "application/octet-stream" }), name+".xlsx");
          } catch (e) {
            if (typeof console !== "undefined") console.log(e, table_write);
          }
          this.isChecked = false;
          return table_write;
        },

        //导出Excel 后台操作直接下载
        expExcel:function(){
          if(this.tradeData.length == 0){
            this.$message.error("没有订单数据，无需导出。");
            return;
          }
          /*//是否通过验证
          if(!this.isChecked){
            this.$message.error( "请先获取验证码，验证通过后再导出。" );
            return;
          }*/
          let fields="";
          let fieldNames="";
          for (let i = 0; i < this.myFields.length; i++) {
            let key = this.myFields[i];
            fields = fields + key.field + ",";
            fieldNames =  fieldNames + key.title + ",";
          }
          let param = {
            isSpan: this.span,
            fields:fields,
            fieldNames:fieldNames,
            nick:  storage.get("nick"),
            venderId:storage.get("venderId"),
            orderId: this.tid,
            onlyWaitSend:this.onlyWaitSend,
            timeField: this.timeField,
            startPayTime: this.payTime[0],
            endPayTime: this.payTime[1],
            sellerFlag: this.sellerFlag,
            title: this.title,
            orderField: this.orderField,
            asc: this.asc,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
            vaildCode: "000",
            needShow: '',
          };
          console.log(this.validCode);
          $api.makeExcel("/trade/excel", param, response=>{
            console.log(response);

          })
        },

        sendCheckCode:function(){
          /*let fields=" 姓名，手机，电话，收货信息，收货地址，详细地址，买家支付宝"
          for(let i=0;i<this.myFields.length;i++){
            if(fields.indexOf(this.myFields[i].title)>0){
              this.$message.error("禁止导出隐私数据, 如需导出，请去除隐私数据！");
              return;
            }
          }*/
          if(this.tradeData.length == 0){
            this.$message.error("没有订单数据，无需导出。");
            return;
          }
          if(this.mobile.length == 0){
            this.$message.error("请输入手机号");
            return;
          }else if(this.mobile.length != 11){
            this.$message.error("请输入11位手机号");
            return;
          }else {
            if (!(/^1[3456789]\d{9}$/.test(this.mobile))) {
              this.$message.error("手机号不正确，请检查");
              return;
            }
          }

          if(this.tradeData.length == 0){
            this.$message.error("没有订单数据，无需导出。");
            return;
          }
          this.$confirm('即将发送验证码，是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            storage.set("mobile", this.mobile);
            let param = {
              nick:storage.get("nick"),
              mobile:this.mobile,
            }
            $api.post("/sms/sendCheckCode", param, response=>{
              let dataResult = response.data;
              if(dataResult.message=="ok"){
                this.$message.success(dataResult.data);
              }else{
                this.$message.error(dataResult.message);
              }
            })

          })


        },
        checkCode:function(){
          if(this.code.length == 0){
            this.$message.error("请输入验证码");
            return;
          }else  if(!(/^\d{6}$/.test(this.code)) ){
            this.$message.error("验证码为6位数字，请检查");
            return;
          }
          let param = {
            nick:storage.get("nick"),
            code:this.code,
          }
          $api.post("/sms/checkCode", param, response=>{
            let dataResult = response.data;
            if(dataResult.message=="ok"){
              this.$message.success(dataResult.data);
              if(dataResult.state == 1){
                //导出只能导出加密的信息
                this.pageObject.pageSize = 5000;
                this.getTradeData();
                this.isChecked = true;
                this.validCode = this.code;
              }
            }else{
              this.$message.error(dataResult.message);
            }
          })
        },

        //改变pageSize
        handleSizeChange: function (val) {
          this.pageObject.pageSize = val;
          this.getTradeData();
        },
        //当前页面改变
        handleCurrentChange: function (val) {
          this.pageObject.pageCurrent = val;
          this.getTradeData();
        },
        copyText:function(){
          /*this.$copyText("<img src='https://img.alicdn.com/bao/uploaded/i4/360449998/O1CN01vqKf0T2Nj8Qheatfk_!!360449998.jpg_40x40.jpg'/>").then(function (e) {
            alert('Copied')
            console.log(e)
          }, function (e) {
            alert('Can not copy')
            console.log(e)
          })*/
          copy.selectText("mytable")
        },

        //获取订单列表数据
        getTradeData: function (needShow) {
          console.log(this.timeField);
          document.getElementById("mytable").style.display = 'block';
          document.getElementById("vTable").style.display = 'none'

          if(this.payTime == null){
            this.payTime=[];
          }
          let param = {
            nick:  storage.get("nick"),
            venderId:storage.get("venderId"),
            orderId: this.tid,
            onlyWaitSend:this.onlyWaitSend,
            timeField: this.timeField,
            startPayTime: this.payTime[0],
            endPayTime: this.payTime[1],
            sellerFlag: this.sellerFlag,
            title: this.title,
            orderField: this.orderField,
            asc: this.asc,
            pageCurrent: this.pageObject.pageCurrent,
            rowCount: this.pageObject.rowCount,
            pageSize: this.pageObject.pageSize,
            needShow: needShow
          };
          console.log("getStart");
          $api.post("/trade/get", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              console.log(dataResult.data.trade);
              let tradeData = dataResult.data.trade;
              let pageObject = dataResult.data.pageObject;
              this.tradeData = tradeData;
              this.pageObject.rowCount = pageObject.rowCount;
              this.pageObject.pageSize = pageObject.pageSize;
              //检测是否需要导出
              if(this.excelFlg == 1){
                this.export2Excel();
                this.excelFlg = 0;
              }
            }
            else {
              this.deny = 1;
              this.$message.error(dataResult);
            }
          })
        },

        batDecrypt: function(){
          if(this.tradeData.length > 0) {
            this.$confirm('批量解密功能会进行流控，非必要情况请勿使用，是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'success'
            }).then(() => {
              if (this.tradeData[0].caid != null) {
                //this.pageObject.pageSize = 100;
                this.excelFlg = 2;
                this.getTradeData('decrypt');
              }

              //document.getElementById("mytable").style.display = 'none';
              //document.getElementById("vTable").style.display = 'block'
              this.excelFlg = 0;
            })
          }
        },

        getTrueInfo:function(){
          // document.getElementById("mytable").style.display = 'none';
          // document.getElementById("vTable").style.display = 'block';
          // copy.selectText("vTable");
          copy.selectText("mytable");
        },
        //解密敏感字段
        decrypt:function(index, row){
          console.log(row.oaid);
          let param={
            nick: storage.get("nick"),
            buyerNick: row.buyerNick,
            receiverName: row.maskName,
            receiverMobile:row.maskMobile,
            receiverPhone: row.maskPhone,
            tid: row.tid,
            caid: row.caid
          }
          $api.post("/trade/decrypt", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.tradeData[index].maskName = dataResult.data.receiverName;
              this.tradeData[index].maskMobile = dataResult.data.receiverMobile;
              this.tradeData[index].maskPhone = dataResult.data.receiverPhone;
              if(row.caid != null)
                this.tradeData[index].maskAddress = dataResult.data.receiverAddress;
              else
                this.tradeData[index].receiverAddress = row.trueAddress;

              let addr = this.tradeData[index].toState + '  ' + this.tradeData[index].toCity + '  '
                + this.tradeData[index].toDistrict ;
              this.tradeData[index].maskAddr1 = addr + '  ' +  this.tradeData[index].maskAddress;;
              this.tradeData[index].maskInfo = dataResult.data.receiverName + ',' + dataResult.data.receiverMobile + ','
                + dataResult.data.receiverPhone + ',' + addr + '  ' +  this.tradeData[index].maskAddress + ',' + '000000';

              this.tradeData[index].trueNick = this.tradeData[index].maskNick;
              this.tradeData[index].trueName = this.tradeData[index].maskName;
              this.tradeData[index].trueMobile =this.tradeData[index].maskMobile;
              this.tradeData[index].truePhone =this.tradeData[index].maskPhone;
              this.tradeData[index].trueAddress =this.tradeData[index].receiverAddress;
              this.tradeData[index].trueInfo =this.tradeData[index].maskInfo;
            }else{
              this.$message.error(dataResult);
            }
          })
        },
        //复制
        change:function (gv) {
          console.log("rows:"+this.tradeData.length);
          let nick = storage.get("nick");
          if(nick != '谢奇代购') {
            if (this.tradeData.length <= 5100) {
              document.getElementById("vTable").style.display = 'block';
              copy.selectText("vTable")
              setTimeout(function () {
                document.getElementById("vTable").style.display = 'none';
              }, 10000);
            }
            console.log("rows end.");
            this.$message.error("");
          }
        },

        tableRowClassName({row, rowIndex}) {
          let rowcnt = row.rowCnt;
          if(rowcnt>1) {
            return 'same-tid';
          }
          return '';
        },
        //全并行
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          let lpage = this.pageObject.pageCurrent;
          let lpagesize = this.pageObject.pageSize;

          if (this.span) { //this.title.length == 0
            let isSpan = 0;
            if(columnIndex>0)
              isSpan = this.myFields[columnIndex-1].span;
            else
              isSpan = 1;
            if ((isSpan == 1) ) {
              let rowcnt = row.rowCnt;
              let rownum = row.rowNum;

              let rspan=1;
              let cspan=1;
              //只要是第0行，不管序号是否为1
              if ((rowIndex == 0) || (rownum == 1)) {
                if (rowcnt - rownum + 1 > lpagesize - rowIndex) {
                  rspan = lpagesize - rowIndex;
                } else {
                  rspan = rowcnt - rownum + 1
                }
                cspan = 1;
              } else {
                rspan = 0;
                cspan = 0;
              }
              return {
                rowspan: rspan,
                colspan: cspan
              }
            }
          }
        },
      },
      mounted() {
        let field = storage.get("field");
        if(field == null){
          this.$message.error("您没有设置显示顺序，请返回保存显示顺序");
        }else{
          this.myFields = field;
          for(let i=0;i<this.myFields.length;i++){
            let item = this.myFields[i];
            let hide = {};
            let str = item.field;
            if(item.field == "maskNick")
              str="trueNick"
            else if(item.field == "maskName")
              str="trueName"
            else if(item.field == "maskMobile")
              str="trueMobile"
            else if(item.field == "maskPhone")
              str="truePhone"
            else if(item.field == "maskInfo")
              str="trueInfo";
            else if(item.field == "maskAddr")
              str="trueAddr";
            else if(item.field == "maskInvoice")
              str="trueInvoice";

            hide.title = item.title;
            hide.field = str;
            hide.span = item.span;
            this.hideFields.push(hide);
          }
        }
        let showImg = storage.get("showImg");
        if(showImg != null) {
          this.showImg = showImg;
        }
        let nicks=",trout鳟鱼,动感哥弟企业店,掏吧no1,森格家居品牌直销店,yang15968894410,艺品汇饰家2016,饭粒旗舰店,ms_tiamo,hosekyao,众艺家居旗舰店,xueping731731,tb836132503,美艺梦旗舰店,黑泽明君,wgaofa";
        let nick= storage.get("nick");
        if(nicks.indexOf(nick)>=0){
          this.bigImg = "1";
        }
        let mobile = storage.get("mobile");
        if(mobile != null){
          this.mobile = mobile;
        }
        //this.getVersion();
        this.getTradeData();
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/ShowData.vue